import { Stack, useMediaQuery, useTheme } from "@mui/material";
import Header from "../components/Header";
import StandardTourProgramPivot from "../components/desktop/standard-tour-program/StandardTourProgramPivot";
import StandardTourProgramPivotMobile from "../components/mobile/standard-tour-program/StandardTourProgramPivotMobile";

export default function StandardTourProgram() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      <Stack p={1} gap={2}>
        <Header title="Standard Tour Program" />
        {isMobile ? (
          <StandardTourProgramPivotMobile />
        ) : (
          <StandardTourProgramPivot />
        )}
      </Stack>
    </>
  );
}
